import { inject } from '@vue/composition-api';import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import { TvToast, spawn, containerClasses } from 'tv-toast';
import options from './options';
export default (function (ctx, inject) {
  var toasts = document.createElement('div');
  containerClasses.forEach(function (c) {
    return toasts.classList.add(c);
  });

  if (options.defaults && options.defaults.containerClasses) {
    options.defaults.containerClasses.forEach(function (c) {
      return toasts.classList.add(c);
    });
  }

  toasts.setAttribute('id', 'toasts');
  document.body.appendChild(toasts);
  var ToastProgrammatic = {
    show: function show(props) {
      if (typeof props === 'string') props = {
        message: props
      };
      return spawn('toasts', props, TvToast, Vue, options);
    },
    success: function success(message) {
      return spawn('toasts', {
        type: 'success',
        message: message
      }, TvToast, Vue, options);
    },
    info: function info(message) {
      return spawn('toasts', {
        type: 'info',
        message: message
      }, TvToast, Vue, options);
    },
    danger: function danger(message) {
      return spawn('toasts', {
        type: 'danger',
        message: message,
        timeout: 20
      }, TvToast, Vue, options);
    },
    warning: function warning(message) {
      return spawn('toasts', {
        type: 'warning',
        message: message,
        timeout: 10
      }, TvToast, Vue, options);
    },
    denied: function denied(message) {
      return spawn('toasts', {
        type: 'denied',
        message: message,
        timeout: 10
      }, TvToast, Vue, options);
    }
  };
  inject('toast', ToastProgrammatic);
});